import { combineReducers, Reducer } from "redux"
import { IAnalyticsState, } from "./analyticsTypes"
import { hospitalAnalyticsReducer } from "./hospitalAnalyticsReducer"
import { userAnalyticsReducer } from "./userAnalyticsReducer"

export const analyticsReducer: Reducer<IAnalyticsState> = combineReducers({
  hospital: hospitalAnalyticsReducer,
  user: userAnalyticsReducer
})
